import React from "react";

const steps = [
  { num: "01", title: "Listen", text: "We start with what's already true — your brand, your category, your customer's actual language. Internal interviews and competitor reads, in writing." },
  { num: "02", title: "Frame", text: "A documented strategy your CFO can verify, your CMO can defend, and your agencies can execute against. No ambiguity left in the brief." },
  { num: "03", title: "Ship", text: "Senior-led delivery across every channel — paid, organic, content, social — under one accountable team, on a fixed-cadence release pattern." },
  { num: "04", title: "Compound", text: "Reporting in business language, monthly. Tests that ship. Wins captured. Losses logged. Year-two is when this work actually compounds." }
];

const Approach = () => (
  <div className="approach">
    {steps.map((s) => (
      <div key={s.num} className="step">
        <div className="num">{s.num}</div>
        <h4>{s.title}</h4>
        <p>{s.text}</p>
      </div>
    ))}
  </div>
);

export default Approach;
